import React, { ReactElement } from 'react';
import FilteredLink from '../filtered-link/filtered-link.component';
import FlexContainer from '../flex-container/flex-container.component';
import TextBlock from '../text-block/text-block.component';
import Image from '../image/image.component';
import ImageControlsBlock from '../image-controls-block/image-controls-block.component';
import FormFieldUpload from '../form-field-upload/form-field-upload.component';
import ImageFileContainer from '../image-file-container/image-file-container.component';
import FormatService from '../../services/format-service';
import useStylesImageContainer from './image-container.styles';
import { FILE_EXTENSION_LIST_IMAGE } from '../../constants/system/file-extensions';

const ImageContainer: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isEditMode,
    isDisabled,
    isImageDeleted,
    withNoOffset,
    name,
    image,
    imageThumbnail,
    imageFile,
    imageFormFieldName,
    defaultImage,
    onImageFileChange,
    onImageFileDelete,
  } = props;

  const { classes } = useStylesImageContainer();

  const disabledClassName: string | undefined = isDisabled ? classes.imageContainerDisabled : undefined;
  const noOffsetClassName: string | undefined = withNoOffset ? classes.imageContainerNoOffset : undefined;

  return (
    <FlexContainer
      isCentered
      className={FormatService.formatClassNames(classes.imageContainer, disabledClassName, noOffsetClassName)}
    >
      {
        !isDisabled && (
          <TextBlock className={classes.imageContainerHelper} />
        )
      }
      {
        isEditMode && !isDisabled && (
          <ImageFileContainer withLargeImage>
            <ImageControlsBlock
              withDelete={!isImageDeleted && !imageFile && (!!image || !!imageThumbnail)}
              onDeleteClick={onImageFileDelete}
            />
            <FormFieldUpload
              isImage
              isDroppable
              isLargeImage
              name={imageFormFieldName}
              uploadFile={imageFile}
              buttonLabel={name}
              defaultPreviewUrl={(!isImageDeleted && (image || imageThumbnail)) || defaultImage}
              acceptedExtensionList={FILE_EXTENSION_LIST_IMAGE}
              onFileChange={onImageFileChange}
              onFileDelete={onImageFileDelete}
            />
          </ImageFileContainer>
        )
      }
      {
        ((isEditMode && isDisabled) || !isEditMode) && (
          !isDisabled ? (
            <FilteredLink isExternal isDisabled={isEditMode && isDisabled} link={image || imageThumbnail}>
              <Image
                isDefault
                text={name}
                link={image || imageThumbnail || defaultImage}
              />
            </FilteredLink>
          ) : (
            <Image
              isDefault
              text={name}
              link={image || imageThumbnail || defaultImage}
            />
          )
        )
      }
    </FlexContainer>
  );
});

export default ImageContainer;
